module.exports = __webpack_public_path__ + "fonts/6907daa.woff";